import { memo, Suspense } from 'react';

import { useOptions } from '../../hooks/useOptions';
import type { LbPost } from '../../types';
import { LbEventPhase, LbEventType } from '../../types';
import { getPostTypes } from '../../utils';

import Header from './Header';
import PartsRenderer from './PartsRenderer';

const Container = ({ post, post: { parts, lastUpdateDate, liveblogPostData } }: { post: LbPost }) => {
  const {
    customComponents: { header: HeaderComponent = Header },
  } = useOptions();

  return (
    <div
      className={`lb-post ${getPostTypes(parts, liveblogPostData)
        .map((t) => `lb-${t.toLowerCase()}`)
        .join(' ')}  ${liveblogPostData?.isSticky ? 'lb-post-sticky' : ''}`}
    >
      <Suspense>
        <HeaderComponent liveblogPostData={liveblogPostData} date={lastUpdateDate} />
      </Suspense>
      <div
        className={`lb-post-wrap ${
          liveblogPostData?.lbPostFSPEvent?.eventPhase === LbEventPhase.PENALTY &&
          liveblogPostData?.lbPostFSPEvent?.eventType === LbEventType.PENALTY
            ? 'lb-penalty-post'
            : ''
        }`}
      >
        <div className='lb-content'>
          <PartsRenderer post={post} parts={post.parts} />
        </div>
      </div>
    </div>
  );
};

export default memo(Container);
